import { cB } from "../../../_utils/cssr/index.mjs";
// --n-menu-box-shadow
export default cB('popselect-menu', `
 box-shadow: var(--n-menu-box-shadow);
`);